import { Settings } from "react-slick";

export const configCooperationSlider: Partial<Settings> = {
  autoplay: true,
  dots: false,
  slidesToShow: 4,
  arrows: false,
  pauseOnHover: false,
  className: "min-w-[0px] w-[100%]",
  speed: 2000,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};
